module.exports = __webpack_public_path__ + "img/ignis-glx-rojo-vulcano.a56ce70d.png";